//NPM
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import * as actions from 'actions';

import {
  fetchingRecommendations,
  areResultsOwnedByUser,
  selectResult,
} from 'selectors';

import Layout from 'Components/Layout/Layout';
import RankedLists from './RankedLists';
import DNAGraph from './DNAGraph';
import ResultsNavigation from './ResultsNavigation';
import ResultsShareButton from './ResultsShareButton';
import RecommendationsList from './Recommendations/RecommendationList';
import ActiveTagFilters from './ActiveTagFilters';
import TagSearchBar from './TagSearchBar';
import ResultCTA from './ResultCTA';

class Results extends Component {
  componentDidMount = () => {
    this.getRecommendations();
  };

  componentDidUpdate = prevProps => {
    if (prevProps.resultUUID !== this.props.resultUUID) {
      this.getRecommendations();
    }
  };

  componentWillUnmount = () => {
    const { setResult } = this.props;
    // when we navigate away from the results page, reset the current result
    setResult(null);
  };

  getRecommendations = () => {
    const { setResult, getDefaultRecommendations, resultUUID } = this.props;
    setResult(resultUUID);
    getDefaultRecommendations();
  };

  getTitle = () => {
    const { result: { user }, areResultsOwnedByUser } = this.props;
    const hasUserName = user && user.first_name && user.last_name;
    if (!areResultsOwnedByUser && hasUserName) {
      return `${user.first_name} ${user.last_name}'s Results`;
    } else {
      return 'Results';
    }
  };

  render() {
    const { isFilteringByTags, isFetching, areResultsOwnedByUser } = this.props;
    return (
      <Layout>
        <div className={`Results-holder`}>
          <div className="Results-heading">
            <h1>Results</h1>
            <ResultsNavigation className="desktop-only" />
            <ResultsShareButton />
          </div>

          <TagSearchBar />

          {isFilteringByTags ? (
            <ActiveTagFilters />
          ) : (
            !isFetching && (
              <React.Fragment>
                <DNAGraph />
                <RankedLists />
              </React.Fragment>
            )
          )}

          <ResultCTA areResultsOwnedByUser={areResultsOwnedByUser} />
          <RecommendationsList areResultsOwnedByUser={areResultsOwnedByUser} />
        </div>
      </Layout>
    );
  }
}

function mapStateToProps(state, props) {
  const { match: { params: { resultUUID } } } = props;
  return {
    resultUUID,
    result: selectResult(state, resultUUID),
    areResultsOwnedByUser: areResultsOwnedByUser(state),
    isFilteringByTags: state.filters.tags.length > 0,
    isFetching: fetchingRecommendations(state),
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      setResult: actions.setResult,
      getDefaultRecommendations: actions.getDefaultRecommendations,
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(Results);



// WEBPACK FOOTER //
// ./src/Components/Pages/Results/index.js